import {
  ALL_FALLBACK_IMAGES,
  FALLBACK_IMAGES_COMMODITIES,
  FALLBACK_IMAGES_CURRENCIES,
} from "../constants/newsFallbackImages";

export function getFallbackImageByCategories(categories, index) {
  const hasCurrencies = categories.some((c) => c.value === "currencies");
  const hasCommodities = categories.some(
    (c) => c.value === "commodity" || c.value === "commodity_group",
  );

  if (hasCurrencies && !hasCommodities) {
    return FALLBACK_IMAGES_CURRENCIES[
      index % FALLBACK_IMAGES_CURRENCIES.length
    ];
  }
  if (hasCommodities && !hasCurrencies) {
    return FALLBACK_IMAGES_COMMODITIES[
      index % FALLBACK_IMAGES_COMMODITIES.length
    ];
  }
  return ALL_FALLBACK_IMAGES[index % ALL_FALLBACK_IMAGES.length];
}

export function getImageForNews(news, categories, index) {
  return news.url_img || getFallbackImageByCategories(categories, index);
}

export function getItemTags(news) {
  return Array.isArray(news.tags) ? news.tags.slice(0, 100) : [];
}

export function getAllTags(news) {
  return Array.isArray(news.tags) ? news.tags : [];
}

export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";
  const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diffSec < 60) return `${Math.floor(diffSec)}s ago`;
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)} min ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  return `${Math.floor(diffSec / 86400)}d ago`;
}

export function getNewsHighlight(dateStr) {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return null;
  const now = new Date();
  const diffMs = now - date;
  const diffHours = diffMs / (1000 * 60 * 60);
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  const isToday = date.toDateString() === now.toDateString();
  if (diffHours < 1) {
    return {
      type: "live",
      icon: "⚡",
      label: "LIVE",
      severity: "danger",
      textClass: "",
    };
  } else if (isToday) {
    return {
      type: "today",
      icon: "🟢",
      label: "TODAY",
      severity: "success",
      textClass: "",
    };
  } else if (diffDays <= 3) {
    return {
      type: "recent",
      icon: "",
      label: "",
      severity: null,
      textClass: "",
    };
  } else if (diffDays > 7) {
    return {
      type: "old",
      icon: "",
      label: "",
      severity: null,
      textClass: "text-gray-500",
    };
  }
  return {
    type: "normal",
    icon: "",
    label: "",
    severity: null,
    textClass: "",
  };
}
